import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function IoBStackAPIFeatures() {
  const benefits = [
    {
      img: img1,
      title: "Real-Time Data Insights ",
      bodycopy: " Get up-to-the-minute updates on assets, orders, and events with real-time tracking, ensuring your business always has the most accurate data."    },
    {
      img: img2,
      title: "Multi-Domain Flexibility",
      bodycopy: " Whether you're in farming, manufacturing, or retail, IOB Proxy seamlessly adapts to your industry with tailored event management and data handling for each domain.",
    },
    {
      img: img3,
      title: "Comprehensive API Support",
      bodycopy:
        " The IOB Proxy provides a robust set of APIs for tracking, managing, and reporting assets, orders, and site activities, making integration with existing systems simple and efficient.",
    },
    {
        img: img3,
        title: "Scalable and Customizable",
        bodycopy:
          "Easily scale and configure IOB Proxy to meet the unique needs of your business, whether managing a small operation or a large, multi-site enterprise.",
      },
      {
        img: img3,
        title: "Secure Authorization",
        bodycopy:
          " With built-in secure authorization protocols, your data remains protected and accessible only to authorized users.",
      },

      {
        img: img3,
        title: "Storage management",
        bodycopy:
          "It enables users to request storage services from storage providers, facilitating efficient storage of goods and materials.",
      },
      {
        img: img3,
        title: " Beckn API",
        bodycopy:
          "TradeHub backend network based api implemented to achieve decentralized and P2P architecture. This is done for wider interoperability among the agrifood ecosysten players.",
      },
  ];
  return (
    <div className="main-wrapper">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Features
      </h2>
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} key={index} className="d-flex">
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
